/**
 * @generated SignedSource<<5b8bc67c1339d89892f21bf5548db6bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PhoneConfirmMutationInput = {
  clientMutationId?: string | null;
  code: string;
};
export type CampaignInputPhoneConfirmChangedMutation$variables = {
  input: PhoneConfirmMutationInput;
};
export type CampaignInputPhoneConfirmChangedMutation$data = {
  readonly phoneConfirm: {
    readonly __typename: "Influencer";
    readonly newPhone: string | null;
    readonly phoneNumber: string | null;
  } | {
    readonly __typename: "PhoneConfirmError";
    readonly errorType: string;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputPhoneConfirmChangedMutation = {
  response: CampaignInputPhoneConfirmChangedMutation$data;
  variables: CampaignInputPhoneConfirmChangedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newPhone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PhoneConfirmError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputPhoneConfirmChangedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputPhoneConfirmChangedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ded57ec04f8994fafa54118f0ce7574",
    "id": null,
    "metadata": {},
    "name": "CampaignInputPhoneConfirmChangedMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputPhoneConfirmChangedMutation(\n  $input: PhoneConfirmMutationInput!\n) {\n  phoneConfirm(input: $input) {\n    __typename\n    ... on Influencer {\n      newPhone\n      phoneNumber\n      id\n    }\n    ... on PhoneConfirmError {\n      errorType\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "22f70d04b8372e3931d5776e97a76a4c";

export default node;
